import { render, staticRenderFns } from "./StockFilter.vue?vue&type=template&id=768311f5&scoped=true&"
import script from "./StockFilter.vue?vue&type=script&lang=js&"
export * from "./StockFilter.vue?vue&type=script&lang=js&"
import style0 from "./StockFilter.vue?vue&type=style&index=0&id=768311f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768311f5",
  null
  
)

export default component.exports